import axios from "axios";
export function upload(file) {
    const token = localStorage.getItem('token')
    const forms = new FormData();
    //这里的file表示给后台传的属性名字，这里看接口文档需要传的的属性
    forms.append("file", file.file); // 获取上传图片信息
    // http://api.fzsyjxh.com/api/v1
    // return axios.post('http://localhost:8081/api/v1/upload', forms, {
    //     headers: {
    //         "content-type": "multipart/form-data",
    //         "Authorization": token,
    //     },
    // })
    return axios.post('http://api.fzsyjxh.com/api/v1/upload', forms, {
        headers: {
            "content-type": "multipart/form-data",
            "Authorization": token,
        },
    })
}